export function reduceString(text: string, textLimit: number) {
  const finalChars = '...'

  return text.length > textLimit
    ? text.slice(0, textLimit - 1 - finalChars.length).concat(finalChars)
    : text
}

export function camelize(str: string) {
  return str
    .replace(/^\w|[A-Z]|\b\w/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase()
    })
    .replace(/\s+/g, '')
}

export function capitalize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
